export default {
  ['title']: 'REGISTER',
  ['submit-text']: 'Submit',
  ['reset-text']: 'Reset',
  ['email']: 'E-mail',
  ['password']: 'Password',
  ['first-name']: 'First Name',
  ['name']: 'Last Name',
  ['telephone']: 'Phone Number',
  ['idNumber']: 'Passport Number',
  ['occupation']: 'Profession',
  ['country-region']: 'Country / Region',
  ['country-region-detail']: 'Address',
  ['post-code']: 'Post Code',
  ['placeholder-input']: 'Please Input',
  ['message-submit-success']: 'Login Success'
}
